export default {"src":"/_next/static/image/public/images/flags/flag_62.948bb42083561d032a35c8d978343c58.svg","height":16,"width":24};